import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { repairTypeSelectOptions } from 'shared/selectOptionsList';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const HomeRepairTypeFilter = ({ disabled = false }) => {
  const { t } = useTranslation();
  const [repairTypeValue, setRepairTypeValue] = useState('ALL');
  const [searchParams, setSearchParams] = useSearchParams();

  const handleRepairTypeChange = (value) => {
    let entries = Object.fromEntries(searchParams);
    Object.keys(entries).forEach((item) => {
      if (item && item.includes('repaired')) {
        searchParams.delete(item);
      }
    });
    if (value != 'ALL') {
      searchParams.set('repaired', value);
    }
    setSearchParams(searchParams);
    setRepairTypeValue(value);
  };

  const setDefaultHomeTypes = () => {
    let entries = Object.fromEntries(searchParams);
    let newRepairedType = 'ALL';
    Object.keys(entries).forEach((item) => {
      if (item && item == 'repaired') {
        newRepairedType = searchParams.get(item);
      }
    });
    setRepairTypeValue(newRepairedType);
  };

  useEffect(() => {
    setDefaultHomeTypes();
  }, [searchParams]);

  return (
    <div className='mt-3'>
      <div className='filter-title mb-2'>
        {t('shaxmatka.homeDetail.repairType')}
      </div>
      <FormControl fullWidth color='formColor' type='newFilterRadioGroup'>
        <RadioGroup
          aria-labelledby='repair-type-radio-buttons-group'
          name='repair-type-radio-buttons-group-name'
          value={repairTypeValue}
          onChange={(event) => handleRepairTypeChange(event.target.value)}
          sx={{ marginLeft: '-10px' }}
        >
          <FormControlLabel
            value='ALL'
            control={<Radio />}
            label={t('common.filter.all')}
            type='radio'
            disabled={disabled}
          />
          {repairTypeSelectOptions.map((option) => (
            <FormControlLabel
              key={option.code}
              value={option.code}
              control={<Radio />}
              label={t(option.label)}
              type='radio'
              disabled={disabled}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  );
};
export default HomeRepairTypeFilter;
